import { showError, isReadOnlyAdmin } from './common';
import axios from 'axios';
import { store } from 'store/index';
import { LOGIN } from 'store/actions';
import config from 'config';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '/'
});

const readonlySelfWrite = ['/api/user/self', '/api/user/avatar'];
const readonlyPricingWrite = [
  '/api/pricing/catalog/oem',
  '/api/pricing/video-sheet',
  '/api/pricing/upstream-recon',
  '/api/pricing/upstream-recon/sync',
  '/api/pricing/upstream-recon/ingest'
];

function pathOf(url) {
  const raw = String(url || '');
  try {
    return new URL(raw, 'http://local').pathname;
  } catch (e) {
    return raw.split('?')[0];
  }
}

function isReadonlyBlocked(config) {
  if (!isReadOnlyAdmin()) return false;
  const method = String(config.method || 'get').toLowerCase();
  const url = String(config.url || '');
  const path = pathOf(url);
  const mutatingGet =
    /\/api\/channel\/(test|update_balance)/.test(path) || /\/api\/pricing\/v3-supplier-keys\/\d+\/test/.test(path);
  if (mutatingGet) return true;
  if (['get', 'head', 'options'].includes(method)) return false;
  if (readonlySelfWrite.some((p) => path === p || path.startsWith(`${p}/`))) return false;
  if (readonlyPricingWrite.includes(path)) return false;
  return true;
}

API.interceptors.request.use((config) => {
  if (isReadonlyBlocked(config)) {
    const message = '当前是只读账号，只能看数据，不能改';
    return Promise.reject({ message, response: { data: { message, success: false } } });
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      store.dispatch({ type: LOGIN, payload: null });
      window.location.href = config.basename + 'login';
    }

    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    showError(error);
    return Promise.reject(error);
  }
);
